<template>
  <div
    :style="{ height: height }"
    class="d-flex justify-content-center align-items-center"
  >
    <div :style="{ height: height }" id="funnelchart" ref="funnelchart"></div>
  </div>
</template>

<script>
export default {
  name: "FunnelChart",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
      default: "300px",
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadFunnelCharts();
    });
  },
  computed: {
    series() {
      return this.data;
    },
  },
  methods: {
    loadFunnelCharts() {
      var options = {
        series: [
          {
            name: "",
            data: [1380, 1100, 990, 880, 740, 548, 330, 300],
          },
        ],
        chart: {
          type: "bar",
          height: this.height,
          dropShadow: {
            enabled: true,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            barHeight: "80%",
            isFunnel: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          dropShadow: {
            enabled: true,
          },
        },
        title: {
          text: "",
          align: "middle",
        },
        xaxis: {
          categories: [
            "Sourced",
            "Screened",
            "Assessed",
            "HR Interview",
            "Technical",
            "Verify",
            "Offered",
            "Hired",
          ],
        },
        legend: {
          show: false,
        },
      };

      var chart = new ApexCharts(
        document.querySelector("#funnelchart"),
        options
      );
      chart.render();
    },
  },
};
</script>
